export default "__VITE_ASSET__CvjXIIHt__"